import { createContext, useContext } from 'react'

import type { TContextType } from './useCard'

// oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- context default placeholder
export const CardContext = createContext<TContextType>({} as TContextType)
export const CardProvider = CardContext.Provider
export const useCardContext = () => useContext(CardContext)
